import { loadSdk } from '../index.js'
import { insert, setVisible } from '@jsx6/jsx6'

export async function videoIdSubstantial(sdkUrl, authorizationToken, lang, documentTypes, chat) {
  if (typeof EID === 'undefined') {
    await loadSdk(sdkUrl)
  } else {
    console.log("EID is already defined, skipping SDK load");
  }

  const reqCheck = await requirementsCheck()
  if (!document.getElementById('videoScanSubstantial')) {
    insert(document.body, <div id="videoScanSubstantial" class="video-scan"></div>)
  }

  let language = chat.options.lang === 'si' ? 'sl': chat.options.lang === 'en' ? 'en': 'hr'
  setVisible(document.getElementById('videoScanSubstantial'), true)
  const videoId = EID.videoId('#videoScanSubstantial', {
    lang: language,
  })

  // TODO ovo treba backend odraditi i vratiti nam authorization token
 /* async function createSession() {
    const resp = await fetch(
      'https://etrust-sandbox.electronicid.eu/v2/videoid.request',
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer tokenic`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
      },
    )
    if (!resp.ok) throw new Error(`Session request failed: ${resp.status}`)
    return resp.json()
  }

  const { id: sessionId, authorization } = await createSession()*/

  videoId.on('completed', ({ id }) => {
    console.log('VideoID Substantial completed, videoId =', id)
    // Todo dogovorit sa Nikolom dal cemo slat isti method ili drukciji
    let message = {
      "type" : "COMMAND",
      "action" : "scanId",
      "processed" : true,
      "data": {
        "method": "getVideoScanResults",
        "params" : {
          "videoId" : id,
            "service": "videoIdSubstantial"
        },
        "provider": "SIGNICAT"
      }
    }
    chat.sendMessage(message)
    setVisible(document.getElementById('videoScanSubstantial'), false)
    //fetchResult(id)
  })

  videoId.on('failed', error => {
    videoId.turnOff()
    videoId.destroy()
    setVisible(document.getElementById('videoScanSubstantial'), false)
    let message = {
      "type" : "COMMAND",
      "action" : "scanId",
      "processed" : true,
      "data": {
        error: error?.message || "Signicat video scan error",
        "provider": "SIGNICAT"
      }
    }
    chat.sendMessage(message)
    console.log("There was an error during videoScan process: ", error)
  })
  videoId.on('phaseStarting', p => p.continue())

  videoId.start({
    authorization: authorizationToken,
    eIDBiometricConsent: true,
    allowedIdTypes: documentTypes
  })
  
  return videoId
}

async function requirementsCheck(){
  try {
    let requirements = EID.videoId.checkRequirementsEager();
    /**
     * type checks {
     *   passed: boolean;
     *   result: {
     *     browser: {};
     *     os: {},
     *     camera: {},
     *     microphone: {},
     *     bandwidth: {}
     *   }
     *
     * }
     */
    return await requirements
  } catch (error){
    console.log("Error during checking requirements:", error)
  }

}